module.exports = __webpack_public_path__ + "static/york_main_5-760b0b0bce431e76d5c5b8f48e2aa109.png";